import React, { useState, useEffect, useContext } from "react";
import { getCreditsByPeriodicidadAsync } from "../../../api/Dashboard";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import BarList from "../../../components/ui/BarList";

const CreditsByPeriodicidad = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState([]);

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditsByPeriodicidadAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDatos(result.data.result || []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSucursal]);

  return (
    <BarList
      items={datos.map((item) => ({
        label: item.periocidad,
        value: item.contador,
      }))}
    />
  );
};

export default CreditsByPeriodicidad;
